import http from './httpClient';
import { clearAccessToken, clearUser } from './tokenService';

export const isAuthenticated = (): boolean => !!localStorage.getItem('access_token');

export interface LoginResponse {
  access_token: string;
  user?: unknown;
}

export const login = async (ecode: string, password: string): Promise<LoginResponse> => {
  const data = await http.post('/api/v1/cto/auth/login', { ecode, password }, { retry: false }) as LoginResponse;
  if (!data?.access_token) throw new Error('No access token');
  return data;
};


export interface MenuPermission {
  menu_desc: string;
  route_path: string;
  icon_name: string;
  display_order: number;
  submenu?: MenuPermission[];
}

export interface PermissionsResponse {
  permissions: MenuPermission[];
}

export const fetchPermissions = async (): Promise<MenuPermission[]> => {
  try {
    const data = await http.get<PermissionsResponse>('/api/v1/cto/auth/permissions');
    return data.permissions || [];
  } catch (error) {
    console.error('Error fetching permissions:', error);
    throw error;
  }
};

export const logout = async (): Promise<void> => {
  try { await http.post('/api/v1/cto/auth/logout', null, { retry: false }); }
  catch(error) {
    console.error('Error during logout:', error);
   }
  finally {
    clearAccessToken();
    clearUser();
  }
};
